import { CustomError } from '@agilelab/plugin-wb-platform-common';
import { Entity, stringifyEntityRef } from '@mainstage/catalog-model';
import { CatalogApi } from '@mainstage/catalog-client';
import { CustomAlertApi } from '../apis';

export const createRefreshEntityFunction =
  (options: {
    entity?: Entity | null;
    catalogApi: CatalogApi;
    alertApi: CustomAlertApi;
  }) =>
  async () => {
    const { entity, alertApi, catalogApi } = options;
    try {
      if (!entity) return;

      await catalogApi.refreshEntity(stringifyEntityRef(entity));

      alertApi.post({
        message: 'Refresh scheduled',
        severity: 'info',
        timeoutMillis: 5000,
      });
    } catch (errorEntity) {
      alertApi.post({
        error: new CustomError(
          'Refresh failed',
          `Entity ${stringifyEntityRef(entity!)} not found`,
        ),
        severity: 'error',
      });
    }
  };

export const encodeBase64PageCursor = (pageCursor: number): string => {
  return Buffer.from(pageCursor.toString(), 'utf-8').toString('base64');
};

export const decodeBase64PageCursor = (pageCursor?: string): number => {
  if (!pageCursor) return 0;
  return Number(Buffer.from(pageCursor, 'base64').toString('utf-8'));
};
